import { render, staticRenderFns } from "./BaseCosmoSubtitle.vue?vue&type=template&id=dae5bb9a&scoped=true"
import script from "./BaseCosmoSubtitle.vue?vue&type=script&lang=js"
export * from "./BaseCosmoSubtitle.vue?vue&type=script&lang=js"
import style0 from "./BaseCosmoSubtitle.vue?vue&type=style&index=0&id=dae5bb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae5bb9a",
  null
  
)

export default component.exports